<template>
    <div class="order-wrap">
        <h3>我的订单</h3>
        <div class="order-wrap_head">
            <div class="order-wrap_head_left">
                <ul>
                    <li :class="{'li-active':params.scene == 0}" @click="selectTypeFun(0)">全部订单</li>
                    <li :class="{'li-active':params.scene == 1}"  @click="selectTypeFun(1)">待付款</li>
                    <li :class="{'li-active':params.scene == 2}"  @click="selectTypeFun(2)">待发货</li>
                    <li :class="{'li-active':params.scene == 3}" @click="selectTypeFun(3)">待收货</li>
                </ul>
            </div>
            <div class="order-wrap_head_right">
                <div class="order-wrap_input">
                    <input type="text" v-model="params.keyword" placeholder="输入商品名称、订单号">
                    <div class="order-wrap_btn" @click="getListFun">
                        <span>搜索</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="order-wrap_list" v-loading="loading">
            <div class="order-wrap_item" v-for="(item,index) in list" :key="index">
                <div class="order-wrap_item_head">
                    <p>
                        <span>{{item.dtTime}}</span>
                        <span class="u-m-l-15">订单号：</span>
                        <span class="order-wrap_item_font1">{{item.orderId}}</span>
                    </p>
                    <p class="order-wrap_item_font1">{{item.statusInfo}}</p>
                </div>
                <div class="order-wrap_item_goods" v-for="(v,k) in item.products" :key="k">
                    <div class="order-wrap_item_goods_img">
                        <img :src="v.image" alt="">
                    </div>
                    <div class="order-wrap_item_con">
                        <p class="u-line-1 order-wrap_item_font1 u-m-t-10">{{v.title}}</p>
                        <p class="order-wrap_item_font2 u-m-t-20">{{v.key_vals}}</p>
                    </div>
                    <div class="u-flex u-row-right u-flex-1">
                        <span class="order-wrap_item_font2">x{{v.num}}</span>
                        <span class="u-m-l-50 order-wrap_item_font1">{{v.price_sale}}元</span>
                    </div>
                </div>
                <div class="order-wrap_item_bottom">
                    <p>
                        <span class="order-wrap_item_font2">合计：</span>
                        <span class="order-wrap_item_font1">{{item.price}}元</span>
                    </p>
                    <div class="order-wrap_item_btns">
                        <span class="m-span-item" @click="$to_link('/centerOrderDetail',{id:item.id})">订单详情</span>
                        <span class="m-span-item span-btn" @click="payFun(item,index)" v-if="item.status == -5">立即付款</span>
                        <el-popconfirm
                            title="确定已经收到货了吗？"
                            @confirm="confirmFun(item)"
                            v-if="item.status == 3"
                        >
                            <span class="m-span-item span-btn" slot="reference">确认收货</span>
                        </el-popconfirm>
                        
                    </div>
                </div>
            </div>

            <div class="u-flex u-row-center" v-if="count > 0">
                <el-pagination
                  background
                  layout="prev, pager, next,total,jumper"
                  @current-change="currentChangeFun"
                  :page-size="params.pagenum"
                  :total="count">
                </el-pagination>
            </div>
        </div>

        <div class="u-flex u-row-center u-m-t-30 u-m-b-80" v-if="list.length == 0">
            <el-empty description="暂无数据"></el-empty>
        </div>
        

        <wx-pay ref="wxPay" @success="paySuccessFun" @cancel="payCancelFun"></wx-pay>
    </div>
</template>

<script>
import wxPay from "@/components/wxpay"
export default {
    components:{
        wxPay
    },
    data(){
        return {
            loading:true,
            params:{
                page:1,
                pagenum:10,
                scene:0,
                keyword:''
            },
            list:[],
            count:0,
            payIndex:-1,//付款索引
        }
    },
    created(){
        this.params.scene = this.$route.query.scene || 0
        this.getListFun()
    },
    methods:{
        //发起支付
        payFun(item,index){
            this.$refs.wxPay.init(item.id)
            this.payIndex = index
        },
        //支付成功
        paySuccessFun(){
            this.list[this.payIndex].status = 2
            this.list[this.payIndex].statusInfo = '待发货'
            this.payIndex = -1
        },
        //支付取消
        payCancelFun(){
            this.payIndex = -1
        },
        //确认收货
        confirmFun(item){
            this.$http.get('orders_qrshouhuo', {orderId: item.id}).then(response => {
                if (response.code == 1) {
                    item.status = 4
                    item.statusInfo = '已完成'
                }else{
                    this.$message.error(response.message)
                }
            })
        },
        //筛选订单
        selectTypeFun(scene){
            this.params.scene = scene
            this.getListFun()
        },
        //获取订单列表
        getListFun(){
            this.loading = true
            this.$http.get('orders_lists', this.params).then(res => {
                console.log(res);
                this.loading = false
                if(res.code == 1){
                    let data = res.data
                    this.list = data
                    this.count = res.count
                }else{
                    this.list = []
                }
            })
        },
        //分页
        currentChangeFun(e){
            this.params.page = e
            this.getListFun()
        }
    }
};
</script>
<style lang="scss">
.order-wrap {
    h3 {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 20px;
        color: #333333;
    }

    .order-wrap_head {
        display: flex;
        justify-content: space-between;
        height: 48px;
        border: 1px solid #cccccc;
        margin-top: 20px;
        .order-wrap_head_left {
            height: 100%;
            ul {
                display: flex;
                height: 100%;
                li {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100%;
                    width: 96px;
                    font-size: 14px;
                    color: #7d7d7d;
                    cursor: pointer;
                    user-select: none;
                    position: relative;
                    &::after {
                        content: "";
                        width: 1px;
                        height: 16px;
                        background: #eeeeee;
                        position: absolute;
                        top: 50%;
                        right: 0;
                        transform: translateY(-50%);
                    }
                }
                .li-active{
                  background: #0073DF;
                  color: #fff;
                   &::after{
                     content: '';
                     display: none;
                   }
                }
            }
        }
        .order-wrap_head_right{
            display: flex;
            align-items: center;
            padding-right: 20px;
            .order-wrap_input{
                display: flex;
                width: 260px;
                height: 32px;
                background: #F9F9F9;
                border: 1px solid #E2E2E2;
                input{
                    border: 0;
                    outline: none;
                    padding: 0 6px;
                    height: 100%;
                    flex: 1;
                }
                .order-wrap_btn{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 60px;
                    height: 100%;
                    user-select: none;
                    cursor: pointer;
                    border-left: 1px solid #E2E2E2;
                    &:active{
                      opacity: 0.6;
                    }
                    span{
                        font-size: 14px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        line-height: 20px;
                        color: #7D7D7D;
                    }
                }
            }

        }
    }

    .order-wrap_list{
        padding-top: 15px;
        .order-wrap_item{
            border: 1px solid #CCCCCC;
            margin-bottom: 30px;
            .order-wrap_item_head{
                display: flex;
                align-items: center;
                justify-content: space-between;
                background: #F9F9F9;
                height: 48px;
                padding: 0 15px;
                border-bottom: 1px solid #CCCCCC;
                span{
                    font-size: 14px;
                    color: #7d7d7d;
                }
            }
            .order-wrap_item_goods{
                display: flex;
                padding: 20px;
                border-bottom: 1px solid #eeeeee;
                .order-wrap_item_goods_img{
                    display: flex;
                    width: 100px;
                    height: 100px;
                    img{
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
                .order-wrap_item_con{
                    width: 500px;
                    margin-left: 20px;
                }
            }
            .order-wrap_item_bottom{
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 50px;
                padding: 0 15px;
                .order-wrap_item_btns{
                    display: flex;
                    .m-span-item{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 96px;
                        height: 30px;
                        border: 1px solid #CCCCCC;
                        font-size: 14px;
                        color: #7d7d7d;
                        margin-left: 20px;
                        cursor: pointer;
                        user-select: none;
                        &:active{
                          opacity: 0.6;
                        }
                    }
                    .span-btn{
                        border: 0;
                        background: #0073DF;
                        color: #fff;
                    }
                }
            }
            .order-wrap_item_font1{
              font-size: 14px;
              color: #333!important;
            }
            .order-wrap_item_font2{
              font-size: 14px;
              color: #999999!important;
            }
        }
    }
}
</style>
